module.exports = __webpack_public_path__ + "img/casa.d70d7ee2.svg";